<template>
	<section class="small-12 residentsListing propertyListingsPage" v-if="property">
		<section class="small-12 columns pageTitle flex justify-center">
			<div class="small-12 flex vertical-align">
				<div class="small-12 large-3 columns">
					<h1 class="small-12 flex vertical-align">
						Residents Overview
					</h1>
				</div>
				<div class="small-12 large-9 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="addMenu" v-if="user">
							<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddResidentMenu()" v-if="user.relationships.company && units_exist">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Add Resident
							</a>
							<a class="blueButton disabledButton disabled flex vertical-align justify-center borderRadius4" v-else>
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Add Resident
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<div class="small-12 flex listingsContainer">
			<section class="small-12 large-8 flex justify-center listings border-right listingsContainerWrap">
				<div class="small-12 columns" style="margin-top:30px;">
					<ul class="small-12 columns float-left">
						<li class="small-12 featureWidget">
							<residents-stats :residents="residents" :late_invoices="late_invoices" :pending_invoices="pending_invoices" :open_invoices="open_invoices" :failed_invoices="failed_invoices" :paid_invoices="paid_invoices" :all_invoices="all_invoices"/>
						</li>
					</ul>
				</div>
				<div class="small-12 columns listingsTitle animated fadeIn">
					<div class="small-12 flex vertical-align">
						<h3 class="small-3 columns flex vertical-align">
							Residents 
						</h3>
						<div class="small-9 columns searchContainer" style="margin-bottom:20px;">
							<ul class="small-12 flex justify-right vertical-align">
								<li class="reportsMenu">
									<a ref="residentsFilters" class="flex justify-center vertical-align borderRadius4" @click="showFilterDropdownMenu()">
										<i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">filter_alt</i>
										Filter
									</a>
									<div ref="residentsFiltersMenu" class="auto filterDropdownMenu animated fadeIn" v-show="show_filter_menu_dropdown">
										<div class="small-12 filterWrap borderRadius4">
											<div class="small-12 filterMenuLabel">
												<p>Quick Filters</p>
											</div>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('enrolled')">
												<i class="material-icons-outlined">verified_user</i>
												Enrolled
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('not_enrolled')">
												<i class="material-icons-outlined">pending</i>
												Not Enrolled
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('invited')">
												<i class="material-icons-outlined">pending_actions</i>
												Invited
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="viewAllListings()">
												<i class="material-icons-outlined">list</i>
												View All
											</a>
										</div>
									</div>
								</li>
								<li class="search show small-12 large-4">
									<input class="border" type="text" placeholder="Search by Name" v-model="search_query" @input="searchResults($event)">
									<i class="material-icons-outlined">search</i>
								</li>
								<li class="addMenu" v-if="user">
									<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddResidentMenu()" v-if="user.relationships.company && units_exist">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Resident
									</a>
									<a class="blueButton disabledButton disabled flex vertical-align justify-center borderRadius4" v-else>
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Resident
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="small-12 columns listingsTable inPage">
					<div class="small-12 columns head">
						<ul class="small-12 columns flex vertical-align">
							<li class="small-12 large-4 columns flex vertical-align">
								<p class="flex vertical-align">
									Name
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Enrollment
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Unit
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Rent
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 columns body">
						<div class="small-12" v-if="search_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<resident :resident="resident" v-for="(resident, index) in queried_results" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No residents have been found matching that name.
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="small-12" v-if="!search_query && filter_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<resident :resident="resident" v-for="(resident, index) in queried_results" :key="index"/>
							</div>
							<div class="small-12 flex listingsDiv" v-if="queried_results.length == 0">
								<div class="small-12 emptyResults flex justify-center">
									<picture class="small-12 flex justify-center">
										<img width="120" :src="empty_image" alt="Nestd Logo in a House">
									</picture>
									<h6 class="small-12 text-center">
										0 results found
									</h6>
									<p class="small-12 text-center">
										No residents match your selected filter.
									</p>
								</div>
							</div>
						</div>
						<div class="small-12" v-if="!search_query && !filter_query">
							<div class="small-12 flex listingsDiv" v-if="residents && residents.length > 0">
								<resident :resident="resident" v-for="(resident, index) in residents" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No residents have been added to this property yet.
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<user-footer/>
			</section>
			<section class="small-12 large-4 columns flex overviewPanel" v-bind:class="{ active: open_add_resident_menu }">
				<div class="small-12" v-if="units_exist">
					<div class="small-12 companyNeeded borderRadius8 border" v-if="!user.relationships.company">
						<picture class="small-12 flex justify-center">
							<img :src="empty_company_image" alt="Company Vector">
						</picture>
						<h2 class="small-12 columns text-center">No Company Found</h2>
						<p class="small-12 columns text-center">Please set up your company first before adding your residents to your properties.</p>
						<div class="small-12 action flex justify-center">
							<router-link :to="{ name: 'SettingsCompany' }" class="blueButton flex vertical-align justify-center borderRadius4">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Set Up Company
							</router-link>
						</div>
					</div>
					<div class="small-12 panelBody flex vertical-align" v-else>
						<late-residents :late_invoices="late_invoices" :all_invoices="all_invoices" />
						<residents-status :late_invoices="late_invoices" :draft_invoices="draft_invoices" :open_invoices="open_invoices" :paid_invoices="paid_invoices" :all_invoices="all_invoices"/>
					</div>
				</div>
				<div class="small-12" v-else-if="!units_exist">
					<div class="small-12 columns nextSteps" style="margin-top:30px;">
						<div class="small-12 table border borderRadius8">
							<div class="small-12 columns tableHead">
								<div class="small-12 tableRow">
									<div class="small-12 tableCell">
										<h4>Follow these steps to get started.</h4>
									</div>
								</div>
							</div>
							<div class="small-12 columns tableBody animated fadeIn">
								<div class="small-12 tableRow">
									<div class="small-12 tableCell">
										<p class="small-12">
											<router-link :to="{ name: 'PropertyUnits', params: { id: property.id } }" class="small-12 text-overflow flex vertical-align justify-between">
												<span class="float-left">
													Create your first unit.
												</span>
												<i class="material-icons-outlined">play_circle_filled</i>
											</router-link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<add-resident-menu :menu_action="open_add_resident_menu" :property="property" :user="user" :company="company" @closeAddResidentMenu="closeAddResidentMenu"/>
			</section>
		</div>
	</section>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import PieChart from '@/components/framework/charts/PieChart.vue'
	import Resident from '@/components/property/residents/Resident.vue'
	import AddResidentMenu from '@/components/property/residents/AddResidentMenu.vue'
	import Renewal from '@/components/property/shared/Renewal.vue'
	import ResidentsActivityTimeline from '@/components/property/residents/ResidentsActivityTimeline.vue'
	import ResidentsStats from '@/components/property/residents/ResidentsStats.vue'
	import LateResidents from '@/components/property/residents/LateResidents.vue'
	import ResidentsStatus from '@/components/property/residents/ResidentsStatus.vue'

	// Import the events
	import { BindPropertyResidents } from '@/events/residents/BindPropertyResidents' 
	import { GetPropertyUnits } from '@/events/units/GetPropertyUnits' 
	import { GetUserAvatarOptions } from '@/events/config/GetUserAvatarOptions' 
	import { GetCurrentMonthInvoices } from '@/events/residents/GetCurrentMonthInvoices'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentsListing',

		/*
		**  Register the components
		*/

		components: {

			UserFooter,
			PieChart,
			Resident,
			AddResidentMenu,
			Renewal,
			ResidentsActivityTimeline,
			ResidentsStats,
			LateResidents,
			ResidentsStatus

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			AbbreviateNumbersFilters,
			BindPropertyResidents,
			GetPropertyUnits,
			GetUserAvatarOptions,
			GetCurrentMonthInvoices

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			},
			user: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			open_add_resident_menu: false,
			empty_company_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fempty-operations.svg?alt=media&token=1ee6789f-1ad3-4348-aeeb-539c8a687584',
			empty_renewals_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Frenewals-empty.svg?alt=media&token=fa218444-251e-4797-95ff-a6e2c09a5daa',
			units_exist: false,
			show_filter_menu_dropdown: false,
			search_query: '',
			filter_query: null,
			queried_results: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					if (property) {

						/*
						**  Bind the residents
						**  @method: @Events/Residents/BindPropertResidents
						*/

						this.bindPropertyResidentsHandler(this.$route.params.id);
 
						/*
						**  Get the units
						**  @method: @Events/Units/GetPropertyUnits
						*/

						this.getPropertyUnitsHandler(this.$route.params.id);

						/*
						**  Get the user avatars
						**  @method: @Events/Config/GetUserAvatarOptions
						*/

						this.getUserAvatarOptionsHandler();

					}

				}

			},

			get_property_units_complete: {

				immediate: true, // Load on created
				handler(get_property_units_complete) {

					/*
					**  Set the units exist prop
					**  @prop: @here
					*/

					if (get_property_units_complete && this.units && this.units.length > 0) this.units_exist = true;

				}

			},

			residents: {

				immediate: true, // Load on created
				handler(residents) {

                    /*
					**  Get the invoices
					**  @method: @Events/Residents/GetCurrentMonthInvoices
					*/

					if (residents.length > 0) this.getCurrentMonthInvoicesHandler();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

		/*
        ** Do this first
        */

        created() {

        	window.addEventListener('click', this.closeFilterMenu);

        },

		beforeDestroy() {

			window.removeEventListener('click', this.closeFilterMenu);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			searchResults: function (event) {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the data
					*/

					if (event) {

						/*
						**  Set the vars
						*/

						if (this.residents.length > 0) {

							return this.residents.filter((item)=>{
								
								if (item.attributes.contact_information.first_name.toLowerCase().includes(this.search_query.toLowerCase()) || item.attributes.contact_information.last_name.toLowerCase().includes(this.search_query.toLowerCase())) {

									return this.queried_results.push(item);

								}

							});

						} else {

							/*
							**  Set the full list of rents
							*/

							return this.queried_results = this.residents;

						}

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Search for a Resident.',
						errorType: 'Application',
						section: 'Residents Overview',
						uid: '3oiIZFl0rUq2zHrzrwA8',
						error: e
					});

				}

			},

			viewAllListings: function() {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.search_query = null;
					this.filter_query = null;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to View All of the Residents Listings',
						errorType: 'Application',
						section: 'Residents Overview',
						uid: 'rPaRdrEz4unRIPyJR3Hz',
						error: e
					});

				}

			},

			filterBy: function(value) {

				try {

					/*
					**  Set the search & filter queries
					**  @prop: @here
					*/
					
					this.search_query = null;
					this.filter_query = value;

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the results
					**  @prop: @here
					*/

					if (this.residents.length > 0) {

						return this.residents.filter((item)=>{

							/*
							**  If enrolled
							*/

							if (value == 'enrolled' && item.attributes.referral.date) return this.queried_results.push(item);

							/*
							**  If not enrolled
							*/

							if (value == 'not_enrolled' && !item.attributes.referral.date) return this.queried_results.push(item);

							/*
							**  If invited
							*/

							if (value == 'invited' && !item.attributes.referral.date && item.attributes.site_enrollment.enroll_resident) return this.queried_results.push(item);

						});

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.residents;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to apply a status filter when filtering residents.',
						errorType: 'Application',
						section: 'Residents Overview',
						uid: 'cml51sjI9hL1VxayLOei',
						error: e
					});

				}

			},

			openAddResidentMenu: function() {

				// Open the menu
				this.open_add_resident_menu = true;

			},

			closeAddResidentMenu: function(value) {

				// Close the menu
				this.open_add_resident_menu = false;

			},

			showFilterDropdownMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (!this.show_filter_menu_dropdown) {

						this.show_filter_menu_dropdown = true;

					} else {

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Show the Filter Dropdown Menu',
						errorType: 'Application',
						section: 'Residents Overview',
						uid: 'w2TaNMPACzcliqxqauWD',
						error: e
					});

				}

			},

			closeFilterMenu(evt) {

				try {

					let containsElement = this.$el.contains(evt.target),
						parentElement = evt.target.parentElement;

					/*
					**  If menu wasn't clicked
					*/

					if (evt.target !== this.$refs['residentsFiltersMenu'] && evt.target !== this.$refs['residentsFilters'] && parentElement !== this.$refs['residentsFilters']) {

						/*
						**  Set the prop
						**  @prop: @here
						*/

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to close the residents filter menu',
						errorType: 'Application',
						section: 'Residents Overview',
						uid: 'lFOODxA7ATddctbbWWkC',
						error: e
					});

				}

		    },

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>